import React from 'react';

import { BsTwitter , BsInstagram } from 'react-icons/bs';

import { FaFacebookF , FaLinkedinIn } from 'react-icons/fa';
const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
          <a href="https://www.linkedin.com/notifications/?filter=all">
            <FaLinkedinIn/>
          </a>
        </div>
        <div>
          <a href="https://twitter.com/iAmSameer_Ali">
            <BsTwitter/>
          </a>
        </div>
        <div>
            <a href="https://www.instagram.com/alisameer440/">
            <BsInstagram/>
            </a> 
        </div>
        <div>
          <a href="https://www.facebook.com/profile.php?id=100005445693842">
            <FaFacebookF/>
          </a>
        </div>
    </div>
  )
}

export default SocialMedia